<form [formGroup]="formGroup">
    <div class="form-row">
        <div class="form-group col-md-6">
            <label for="nome">Nome del rilievo*</label>
            <input class="form-control" maxlength="250" id="nome" formControlName="nome" type="text">
        </div>
        <div class="form-group col-md-6">
            <label for="soggettoEsecutore">Soggetto esecutore del rilievo*</label>
            <input class="form-control" id="soggettoEsecutore" formControlName="soggettoEsecutore" type="text">
        </div>
        <div class="form-group col-md-6">
            <app-toolkit-datepicker
                label="Data inizio rilievo*"
                formControlName="dataInizioRilievo"
                [disabled]="formGroup.controls['dataInizioRilievo'].disabled">
            </app-toolkit-datepicker>
        </div>
        <div class="form-group col-md-6">
            <app-toolkit-datepicker
                label="Data fine rilievo"
                formControlName="dataFineRilievo"
                [disabled]="formGroup.controls['dataFineRilievo'].disabled">
            </app-toolkit-datepicker>
        </div>
        <div class="form-group col-md-6">
            <label for="importo">Importo rilievo (€)</label>
            <input currencyMask [options]="{inputMode: natural,allowNegative: false, align: 'left', prefix: '€ ', thousands: '.', decimal: ',' }" class="form-control" id="importo" formControlName="importo" type="text">
        </div>
        <div class="form-group col-md-12">
            <label for="estremiAttoIncarico">Estremi atto di incarico per rilievo (Convenzione, incarico)</label>
            <textarea maxlength="500" class="form-control" id="estremiAttoIncarico" formControlName="estremiAttoIncarico" type="text"></textarea>
        </div>
        <div class="form-group col-md-12">
            <label for="descrizione">Descrizione rilievo*</label>
            <textarea class="form-control" id="descrizione" maxlength="1000" formControlName="descrizione"></textarea>
        </div>
    </div>
</form>